import { watch, nextTick } from 'vue'
import pinia from "@/stores/create-store"
import { useAppStore } from '@/stores/app/app'

const storeApp = useAppStore(pinia)

/**
	* autosizeTextareas
	* Auto resize textareas to fit their content
*/
export const autosizeTextareas = {
  mounted(el) {
    el.style.overflow = 'hidden';
    el.style.resize = 'none';

    const resizeTextarea = () => {
      el.style.height = 'auto';  // Reset height to auto to get the correct scrollHeight
      el.style.height = `${el.scrollHeight}px`;
    };

    const onVisibilityChange = (entries) => {
      if (entries[0].isIntersecting) {  // Check if the element is visible
        resizeTextarea();
      }
    };

    // Create an intersection observer to handle visibility changes
    const observer = new IntersectionObserver(onVisibilityChange, {
      threshold: 0.1  // Trigger if at least 10% of the element is visible
    });
    observer.observe(el);

    el.addEventListener('input', resizeTextarea);
    resizeTextarea();  // Initial resize

    // Watch for when a modal opens and resize the
    // textarea if using the directive
    watch(() => storeApp.modal, modalStatus => {
      // Timeout to wait for modal to fully open
      if(modalStatus.event == 'opened')
        setTimeout(() => resizeTextarea(), 300)
    })

    // Cleanup function to remove observer and event listener
    return () => {
      observer.disconnect();
      el.removeEventListener('input', resizeTextarea);
    };
  }
};

/**
	* autosizeTextareasInput
	* Auto resize textareas to fit their content but appears
  * as a normal input that resizes rather than a textarea
*/
export const autosizeTextareasInput = {
  mounted(el) {
    el.style.overflow = 'hidden';
    el.style.resize = 'none';

    const resizeTextarea = () => {
      el.style.height = 'auto';  // Reset height to get correct scrollHeight
      el.style.height = `${el.scrollHeight}px`;  // Set height to content height
    };

    const onVisibilityChange = (entries) => {
      if (entries[0].isIntersecting) {  // Check if the element is visible
        resizeTextarea();
      }
    };

    // Create an intersection observer to handle visibility changes
    const observer = new IntersectionObserver(onVisibilityChange, {
      threshold: 0.1  // Trigger if at least 10% of the element is visible
    });
    observer.observe(el);

    el.addEventListener('input', resizeTextarea);
    resizeTextarea();  // Initial resize

    // Watch for when a modal opens and resize the
    // textarea if using the directive
    watch(() => storeApp.modal, modalStatus => {
      // Timeout to wait for modal to fully open
      if(modalStatus.event == 'opened')
        setTimeout(() => resizeTextarea(), 300)
    })

    // Cleanup function to remove observer and event listener
    return () => {
      observer.disconnect();
      el.removeEventListener('input', resizeTextarea);
    };
  }
};